import React, { useState } from "react";
import PropTypes from "prop-types";

const SUMMARY_KEYS = [
  { key: "succeeded", label: "Succeeded" },
  { key: "blocked", label: "Blocked (active call)" },
  { key: "noOp", label: "No-op" },
  { key: "errored", label: "Errored" }
];

const BulkResultsSummary = ({ result }) => {
  const [showDetails, setShowDetails] = useState(false);
  const results = result?.results || [];

  return (
    <div className="patient-outreach-bulk-results">
      <p className="patient-outreach-bulk-results__totals">
        {SUMMARY_KEYS.map(({ key, label }) =>
          typeof result[key] === "number" ? (
            <span key={key} className={`bulk-pill bulk-pill--${key}`}>
              {label}: {result[key]}
            </span>
          ) : null
        )}
      </p>

      {results.length > 0 && (
        <>
          <button
            type="button"
            className="patient-outreach-bulk-results__toggle"
            onClick={() => setShowDetails(s => !s)}
          >
            {showDetails ? "Hide" : "Show"} per-patient breakdown ({results.length})
          </button>
          {showDetails && (
            <ul className="patient-outreach-bulk-results__list">
              {results.map(r => (
                <li
                  key={r.patientGuid}
                  className={`bulk-result bulk-result--${(r.outcome || "").toLowerCase()}`}
                >
                  <code>{r.patientGuid}</code>
                  <strong> — {r.outcome}</strong>
                  {r.reason && <span className="reason"> ({r.reason})</span>}
                </li>
              ))}
            </ul>
          )}
        </>
      )}
    </div>
  );
};

BulkResultsSummary.propTypes = {
  result: PropTypes.shape({
    totalRequested: PropTypes.number,
    succeeded: PropTypes.number,
    blocked: PropTypes.number,
    noOp: PropTypes.number,
    errored: PropTypes.number,
    results: PropTypes.array
  }).isRequired
};

export default BulkResultsSummary;
